module.exports = __webpack_public_path__ + "static/media/checkIcon.e26463e3.svg";